var _path;

var _excluded = ["svgRef"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var SvgYoutube = function SvgYoutube(_ref) {
  var svgRef = _ref.svgRef,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "social-youtube-footer-fix",
    "data-name": "f91d7e40-91f4-4494-bd0c-a3bb0e9b73ce",
    viewBox: "0 0 160.08 160",
    ref: svgRef
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M158.14,46.55a20.59,20.59,0,0,0-17.9-18.1,468.12,468.12,0,0,0-120.6,0,20.49,20.49,0,0,0-17.8,18.1,299.31,299.31,0,0,0,0,66.9,20.49,20.49,0,0,0,17.8,18.1,469.15,469.15,0,0,0,60.4,3.9,467.72,467.72,0,0,0,60.3-3.9,20.51,20.51,0,0,0,17.8-18.1A290.74,290.74,0,0,0,160,80,289,289,0,0,0,158.14,46.55Zm-54.9,36.6-32.8,23.1a2.89,2.89,0,0,1-4-.7,2.58,2.58,0,0,1-.5-1.7V56a2.88,2.88,0,0,1,2.8-2.9,3.3,3.3,0,0,1,1.7.5l32.8,23.1a3.9,3.9,0,0,1,1,5.42l-.06.08A3.1,3.1,0,0,1,103.24,83.15Z",
    transform: "translate(0.04)",
    fill: "#ffffff",
    stroke: "none"
  })));
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgYoutube, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/youtube.80003434.svg";
export { ForwardRef as ReactComponent };